import { getProvidersOfMeBasicApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'providersOfMeBasic';

export const getProvidersOfMeBasic = getAllCustom(
  MODEL_NAME,
  getProvidersOfMeBasicApi,
);
